<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "chocolate" type = "line-scale-pulse-out" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
